import React from 'react';
import Carousel from 'nuka-carousel';
import { FaAngleRight, FaAngleLeft }from "react-icons/fa";



export default class extends React.Component {
  render() {
    return (
      <div>
        <section className="banner-Coveris">
          <div className="banner-Coveris-left">
            <img src="baner-podpis.jpg" alt="" />
            <div className="image-overlay"></div>
          </div>
          <div className="banner-Coveris-right">
            <h2>Hadepol Flexo i Coveris łączą siły.<br/>Połączenie lokalnego doświadczenia i międzynarodowego know-how. </h2>
            <p>Szanowni Państwo, <br/>Z przyjemnością ogłaszamy, że Hadepol Flexo został przejęty przez Grupę Coveris. Od 3. kwietnia 2025 firma działa pod nową nazwą Coveris Rypin Sp. z o.o. <br/><br/> 
              Lokalna niezawodność Hadepol Flexo od teraz wspierana jest przez międzynarodową sieć Coveris. Posiadając 30 lokalizacji w 8 krajach, Coveris ma długą historię rozwoju i produkcji innowacyjnych rozwiązań w zakresie opakowań papierowych i plastikowych. Nasze dążenie do doskonałości spełnia wysokie standardy w zakresie ochrony produktów, bezpieczeństwa, wygody użytkowania, trwałości, zrównoważonego rozwoju i promocji.<br/>
            Z niecierpliwością czekamy na kolejny rozdział naszej współpracy! </p>
            <a href="https://www.coveris.com/media/newsroom/coveris-kontynuuje-rozwoj-dziki-przejciu-firmy-hadepol-flexo-w-polsce" target="_blank">Coveris kontynuuje rozwój dzięki przejęciu firmy HADEPOL FLEXO w Polsce</a>
          </div>
        </section>
        <Carousel
          className="head-slider"
          autoplay="true"
          wrapAround="true"
          pauseOnHover="false"
          renderCenterLeftControls={({ previousSlide }) => (
              <button onClick={previousSlide}>
                <FaAngleLeft />
              </button>
            )}
            renderCenterRightControls={({ nextSlide }) => (
              <button onClick={nextSlide}>
                <FaAngleRight />
              </button>
          )}
        >

          <img src="baner_540.jpg" alt="" />
          <img src="Baner_1.jpg" alt="" />
          <img src="Baner_2.jpg" alt="" />
          <img src="baner_bielawki.jpg" alt="" />
        </Carousel>
      </div>
    );
  }
}